import React, { useState, useEffect, Fragment } from 'react';
import services from '../services';
import { bplMasterDataSyncSchemaObject } from '../bplMasterDataSyncSchema';
import { Fields, validateProperty, validate, Card } from "../../Common"
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi'
import { PageHeader } from '../../../Common';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';

const screenCode = 'BPLMASTERDATASYNC';

export function BPLMasterDataAddEdit(props) {

    const { data, edit } = props.location
    const [title, setTitle] = useState("Sync BPL Master Data")
    const [groups, setGroups] = useState()
    const [estates, setEstates] = useState()
    const [bplMasterDataTypes, setBPLMasterDataTypes] = useState()
    const [syncData, setSyncData] = useState({
        groupID: "0",
        operationEntityID: "0",
        masterDataTypeID : "0"
    });
    const [buttonName, setButtonName] = useState("Sync");
    const [errors, setErrors] = useState({})
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    })

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    const schema = Joi.object(bplMasterDataSyncSchemaObject).options({ allowUnknown: true })

    useEffect(() => {
        getPermissions();
        getBPLMasterDataTypes();
    }, []);

    useEffect(() => {
        trackPromise(
            getEstates()
        )
    }, [syncData.groupID])

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITBPLMASTERDATASYNC');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });


        if (data && edit) {
            setTitle("Edit syncData");
            setSyncData(data);
            setButtonName("Update");
            
        } else {
            
            setTitle("Sync BPL Master Data");
            var token = tokenService.getUserDetailsFromToken();
            setSyncData({
                ...syncData,
                groupID: token.groupID,
                operationEntityID: token.operationEntityID
            });
        }
        trackPromise(
            getAllGroups()
        )
    }

    function handleGroupChange(target) {
        validateInputs(target);

        setSyncData({
            ...syncData,
            groupID: target.value,
            operationEntityID: '0',
            collectionPointID:'0'
        })
    }

    function handleOperationEntityChange(target) {
        validateInputs(target);

        setSyncData({
            ...syncData,
            operationEntityID: target.value,
            collectionPointID: '0'
        })
    }

    function handleMasterDataTypeChange(target) {
        // validateInputs(target);

        setSyncData({
            ...syncData,
            masterDataTypeID: target.value
        })
    }
    
    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, bplMasterDataSyncSchemaObject);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setErrors(error)
    }

    async function handleSave(e) {
        e.preventDefault();

        const errorMessages = validate(schema, syncData)
        errorMessages !== null ? setErrors(errorMessages) : setErrors({})
        if (errorMessages) return

            if (!edit) {
                const response = await services.syncData(syncData);
                setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
                afterSuccessfulyChanged(response.statusCode)
            }
            if (edit) {
                const response = await services.syncData(syncData);
                setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
                afterSuccessfulyChanged(response.statusCode)
            }
    }

    function afterSuccessfulyChanged(response) {

        if (response === "Success") {

            setTimeout(() => {
                // props.history.push({ pathname: '/bplMasterDataSync' })
            }, 1500);
        }
    }

    async function getEstates() {
        const result = await services.getEstatesByGroupID(syncData.groupID)
        setEstates(result)
    }

    async function getAllGroups() {
        const result = await services.getGroups()
        setGroups(result)
    }

    async function getBPLMasterDataTypes() {
        const result = await services.getBPLMasterDataTypes()
        setBPLMasterDataTypes(result)
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>)
            }
        }
        return items
    }

    function clearButton() {
        setErrors({});
        var token = tokenService.getUserDetailsFromToken();
        setSyncData({
            ...syncData,
            groupID: !permissionList.isGroupFilterEnabled ? '0' : token.groupID,
            operationEntityID: !permissionList.isOperationEntityFilterEnabled ? '0' : token.operationEntityID,
            masterDataTypeID: 0
        });
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <PageHeader
                                    title={title}
                                    isButtonEnable={true}
                                    buttonText="Back to Listing"
                                    path="/bplMasterDataSync"

                                />
                            </div>
                            <hr />

                            <form onSubmit={(e) => handleSave(e)}>

                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            name="groupID"
                                            value={syncData.groupID}
                                            onChange={(e) => handleGroupChange(e.target)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Estate *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="operationEntityID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            name="operationEntityID"
                                            value={syncData.operationEntityID}
                                            onChange={(e) => handleOperationEntityChange(e.target)}>
                                            <MenuItem value="0">--Select Estate--</MenuItem>
                                            {generateDropDownMenu(estates)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="masterDataTypeID">Master Data Type</InputLabel>
                                        <Select
                                            fullWidth
                                            id="masterDataTypeID"
                                            name="masterDataTypeID"
                                            value={syncData.masterDataTypeID}
                                            onChange={(e) => handleMasterDataTypeChange(e.target)}>
                                            <MenuItem value="0">--All--</MenuItem>
                                            {generateDropDownMenu(bplMasterDataTypes)}
                                        </Select>
                                        {/* {errors["masterDataTypeID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["masterDataTypeID"]}</FormHelperText>} */}
                                    </div>
                                </div>

                                <MessageModal
                                    hidden={messageModel.hidden}
                                    messageType={messageModel.type}
                                    messageDescription={messageModel.disciption}
                                    clicked={modalDismissHandler}
                                />

                                <div className="card-footer">
                                    <input
                                        type="submit"
                                        className="btn btn-primary"
                                        value={buttonName}
                                        onClick={(e) => trackPromise(handleSave(e))}
                                    />
                                    <input
                                        type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={clearButton}
                                    />
                                </div>
                            </form>

                        </div>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}